import { once } from "~/jose_modern/once.js";

export function initCsvDownload(container) {
  const link = container.querySelector("[data-csv-download-base]");
  if (!link) return;

  once(link, "csv-download", (el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      const base = el.dataset.csvDownloadBase;
      const params = new URLSearchParams(window.location.search);
      params.delete("page");
      params.delete("per_page");
      window.location.href = `${base}?${params.toString()}`;
    });
  });
}
